<div class="widget" [class.initial]="invalid">
  <div class="widget-header">
    <span class="custom-icon">
      <span class="icon material-icons">assignment</span>
    </span>
    <span class="title">{{ formName }}</span>
  </div>
  <div class="widget-content">

      <div *ngIf="!stageId">Not connected to a stage</div>

      <div class="progress-bar" [style.background]="background" [attr.data-percentage]="percentage" *ngIf="stageId && !isDeadlinePassed && !isSubmitted && !invalid">
        <progress [value]="percentage" min="0" max="100">{{ percentage }}%</progress>
      </div>

      <div *ngIf="stageId && isDeadlinePassed && !isSubmitted && !invalid" class="custom-message">
        <span class="icon material-icons passed-deadline">cancel</span>
        <p>We're sorry, but the submission deadline has passed</p>
      </div>

      <div *ngIf="stageId && isSubmitted && !invalid" class="custom-message">
        <span class="icon material-icons submitted">check_circle</span>
        <p>Thank you for submitting your application!</p>
      </div>

      <div *ngIf="stageId && invalid" class="default-state">
        <img src="assets/images/widget/lock.png"/>
        <span class="inner-title">{{ formName }}</span>
        <span class="inner-message">Unlocking soon...</span>
      </div>

      <button class="button" [ngClass]="!isDeadlinePassed && !isSubmitted? 'button-primary' : 'button-secondary'" *ngIf="stageId && !invalid" [routerLink]="buttonLink">         
        {{ buttonText }}
      </button>
   
  </div>
</div>